import { useContext } from "react";
import { ToastContext } from "./ToastContext.js";
import { isToastMaster } from "./utils.js";
function useToasts() {
  const { toastMaster, toasts } = useContext(ToastContext), toastMasterPresent = isToastMaster(toastMaster);
  function addToast(toast) {
    if (toastMasterPresent)
      return toastMaster.addToast(toast);
  }
  function expireToast(toastId) {
    toastMasterPresent && toastMaster.expireToast(toastId);
  }
  return {
    addToast,
    expireToast,
    toasts
  };
}
export {
  useToasts
};
//# sourceMappingURL=useToasts.js.map
